import { lazy, type FC, type ReactElement, Suspense } from 'react'

import { Loader } from '../components/Loader'
import { useRequireAuth } from '../hooks/useRequireAuth'
import { updatePlatformHeader } from '../services/api/auth'
import { setPlatformForLogs } from '../services/datadog'

const LazyTrustedDeviceManagementPage = lazy(() =>
  import('../pages/TrustedDeviceManagement/TrustedDeviceManagementPage').then((module) => ({
    default: module.TrustedDeviceManagementPage,
  })),
)

export const TrustedDeviceManagementAndroidRoute: FC = (): ReactElement => {
  const platform = 'android'

  updatePlatformHeader(platform)
  setPlatformForLogs(platform)

  const { isAuthenticated } = useRequireAuth()

  if (!isAuthenticated) {
    return <Loader />
  }

  return (
    <Suspense fallback={<Loader />}>
      <LazyTrustedDeviceManagementPage showBackButton={false} />
    </Suspense>
  )
}
